import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';

const Title: React.FC<TypographyProps> = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.pxToRem(22),
    color: theme.palette.primary.main,
    margin: theme.spacing(3, 1),
  },
}))((props) => <Typography {...props} component="h2" align="center" />);

export default Title;
